import { render, staticRenderFns } from "./SelectPlayer.vue?vue&type=template&id=54ff11d0"
import script from "./SelectPlayer.vue?vue&type=script&lang=ts"
export * from "./SelectPlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports